import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import styles from './styles.module.scss';

import { ReactComponent as Icon } from '../../../assets/icons/icon-search.svg';
import { alphanumericChars } from '../../../utils/format/character_restriction';
import { lang } from '../../../config/config';

const { localStorage } = window;
let searchHistory = [];

const cleanHistory = (items) => {
  const history = items.length > 4 ? items.slice(-4) : items;
  const output = history.filter(
    (item) =>
      item !== '' &&
      item !== ',' &&
      item !== 'undefined' &&
      item !== null &&
      item !== undefined
  );
  return output;
};

export const SearchButton = ({ toggleSearchbox }) => (
  <div className={styles.searchButton}>
    <button type="button" onClick={toggleSearchbox}>
      <Icon />
    </button>
  </div>
);

const History = ({ hideSearchbox, searchHandler }) => {
  const getHistory = localStorage.getItem('searchHistory');
  const buildHistory =
    getHistory !== null && getHistory.length ? getHistory.split(',') : [];
  const setHistory = cleanHistory(buildHistory);
  const history = setHistory.length > 4 ? setHistory.slice(-4) : setHistory;

  const removeItem = (item) => {
    searchHistory = searchHistory.filter((term) => term !== item);
    hideSearchbox();
    if (searchHistory.length) {
      searchHistory = cleanHistory(searchHistory);
      localStorage.setItem('searchHistory', searchHistory);
    } else {
      localStorage.clear();
      searchHistory = [];
    }
  };
  const changeValue = (e) => {
    e.preventDefault();
    const input = document.getElementById('inputSearch');
    input.value = e.target.text;
    const btnSearch = document.getElementById('btnSearch');
    searchHandler(e);
    setTimeout(() => {
      btnSearch.click();
    }, 500);
  };
  return (
    <div className={styles.history}>
      {history.map((item, key) => (
        <div className={styles.historyItem} key={key}>
          <Link
            to="/"
            onClick={(e) => {
              changeValue(e);
            }}
          >
            {item}
          </Link>
          <button type="button" onClick={() => removeItem(item)}>
            Eliminar
          </button>
        </div>
      ))}
    </div>
  );
};

export const SearchBoxMobile = ({ close }) => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState('');
  const searchHandler = (e) => {
    setSearchTerm(e.target.value || e.target.text);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    if (!searchTerm) return;
    if (!searchHistory.some((el) => el === searchTerm))
      searchHistory.push(searchTerm);
    localStorage.setItem('searchHistory', cleanHistory(searchHistory));
    close();
    history.push(`${lang}/category/search`, { searchTerm });
  };
  return (
    <form className={styles.searchBoxMobile} onSubmit={onSubmit}>
      <Icon onClick={onSubmit} />
      <input
        type="search"
        placeholder="¿Qué estás buscando?"
        onKeyPress={alphanumericChars}
        onChange={searchHandler}
      />
    </form>
  );
};

export const SearchBox = ({ active, hideSearchbox }) => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState('');
  const searchHandler = (e) => {
    setSearchTerm(e.target.value || e.target.text);
    const btnSearch = document.getElementById('btnSearch');
    btnSearch.setAttribute('class', e.target.value || e.target.text);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    if (!searchHistory.some((el) => el === searchTerm)) {
      searchHistory.push(searchTerm);
    }
    searchHistory.push(searchTerm);
    localStorage.setItem('searchHistory', cleanHistory(searchHistory));
    hideSearchbox();
    history.push(`${lang}/category/search`, { searchTerm });
  };

  return (
    <div className={styles.searchBoxContainer}>
      <div
        className={`${styles.searchBox} ${
          active ? styles.searchBoxActive : ''
        }`}
      >
        <form
          id="formSearch"
          className={styles.searchBoxForm}
          onSubmit={onSubmit}
        >
          <input
            id="inputSearch"
            type="search"
            placeholder="por nombre, por número de producto o por descripción"
            onChange={searchHandler}
            onKeyPress={alphanumericChars}
          />
          <button id="btnSearch" type="submit" className="">
            <Icon />
          </button>
        </form>
        <History
          hideSearchbox={hideSearchbox}
          onSubmit={onSubmit}
          searchHandler={searchHandler}
        />
      </div>
    </div>
  );
};
